import React from "react"
import {Title} from "../../components"
import {SnailItemProps} from "../props"

const StandardSnailItem = ({isActive, linkColour, fontWeight, title}: SnailItemProps) => (
    <Title isActive={isActive} fontWeight={fontWeight} linkColour={linkColour}>
        {/* Todo: Tech Debt - User Story 390195 */}
        {/* https://dev.azure.com/Next-Technology/Ecom.Backlog/_workitems/edit/390195 */}
        {title}
    </Title>
)

export default StandardSnailItem
